module.exports = __webpack_public_path__ + "media/seher_1.1g.9db83c49.mp3";